import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import FontIcon from 'material-ui/FontIcon';
import _ from 'lodash';

import { logoutRoutine } from '../../routines';
import { showDialog, isDialogOpen } from '../../actions/dialogs';
import FindJobDialog from '../FindJobDialog';
import UserProfile from '../Authentication/Profile';
import { getProfile } from '../../utils/authenticated';
import ConfirmDialog from '../Common/ConfirmDialog';
import AlertDialog from '../Common/AlertDialog';
import { hasPermission, getTenant } from '../../utils/authenticated';
import TaskUploadDialog from '../TaskUploadDialog';
import AddressDialog from '../AddressDialog';
import ContactDialog from '../ContactDialog';
import TagDialog from '../TagDialog';
import LoadingOverlay from '../Common/LoadingOverlay';
import UpgradeDialog from '../UpgradeDialog';
import CreditCardCapture from '../CreditCardCapture';

import styles from './styles';

const SelectableList = makeSelectable(List);

class Dashboard extends Component {

  static propTypes = {
    logoutUser: PropTypes.func.isRequired,
    showDialog: PropTypes.func.isRequired,
    dialogs: PropTypes.object.isRequired,
    children: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,

    isFindJobVisible: PropTypes.bool.isRequired,
    isProfileVisible: PropTypes.bool.isRequired,
    tenant: PropTypes.object.isRequired,
  };

  state = {
    openReportsMenu: false,
    tenant: getTenant(),
  };

  handleLogOut = () => {
    this.props.logoutUser();
    // .then(() => {
    // reload props from reducer
    // this.props.fetchUser();
    // });
  };

  handleReportsClick = () => {
    this.setState({
      openReportsMenu: !this.state.openReportsMenu,
    });
  };

  handleOnRequestChange = (value) => {
    console.log('handleOnRequestChange', value);
    this.setState({
      openReportsMenu: value,
    });
  };

  handleReportSelect = (report) => {
    console.log('handleReportSelect', report);
  };

  handleShowJobReport = (report) => {
    this.props.showDialog('findjob', {
      report,
      onSelect: (jobId) => this.props.push(`/reports/${report}/${jobId}`),
    });
  };

  handleMenuSelect = (evt, menuItem) => {
    console.log('handleMenuSelect', menuItem);
    this.setState({
      selectedMenuItem: menuItem,
    });
  };

  renderTrial = () => {
    return (<div style={styles.row}>
      <div style={styles.column}>
        <FontIcon className="material-icons" color="white" style={styles.warningIcon}>warning</FontIcon>
      </div>
      <div style={styles.column}>
        <div>Free Trial</div>
      </div>
      <div style={styles.column}>
        <RaisedButton
          label="Upgrade"
          secondary
          style={styles.upgrade}
          onClick={() => this.props.showDialog('upgrade')} />
      </div>
    </div>);
  };

  renderUserMenu = () => {
    const { tenant } = this.props;
    const user = getProfile();

    if (user) {
      return (<div style={styles.row}>
        { tenant.settings && tenant.settings.plan ? null : this.renderTrial() }
        <div style={styles.column}>
          <span
            style={styles.employeeName}>{user && user.user_metadata ? `${user.user_metadata.firstName || ''} ${user.user_metadata.lastName || ''}` : 'Unknown'}</span>
          <span style={styles.tenantName}>{tenant.name || 'Unknown'}</span>
        </div>
        <IconMenu
          iconButtonElement={
            <IconButton iconStyle={styles.icon}><MoreVertIcon /></IconButton>
          }
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <MenuItem primaryText="Help" containerElement={<Link target="_blank" to="https://help.staza.io"/>}/>
          <MenuItem primaryText="Log out" onClick={() => this.props.logoutUser() }/>
        </IconMenu>
      </div>);
    } else {
      return (<FlatButton label="Login"/>);
    }
  };

  render() {
    const { dialogs } = this.props;
    return (
      <div style={styles.container}>
        <LoadingOverlay visible={isDialogOpen(this.props.dialogs, 'loading')}/>
        <Drawer width={250} open docked>
          <AppBar title={<Link to="/"><img alt="logo" src="/images/logo.png" style={styles.logo}/></Link>}/>
          <SelectableList
            value={this.state.selectedMenuItem}
            onChange={this.handleMenuSelect}
          >
            <ListItem
              primaryText="Customers"
              value="customers"
              containerElement={<Link to="/customers"/>}
              leftIcon={<FontIcon className="material-icons">business</FontIcon>}
            />
            <ListItem
              primaryText="Jobs"
              value="jobs"
              containerElement={<Link to="/jobs"/>}
              leftIcon={<FontIcon className="material-icons">transform</FontIcon>}
            />
            <ListItem
              primaryText="Employees"
              value="employees"
              containerElement={<Link to="/employees"/>}
              leftIcon={<FontIcon className="material-icons">person</FontIcon>}
            />
            <ListItem
              primaryText="Scheduling"
              value="scheduling"
              containerElement={<Link to="/scheduling"/>}
              leftIcon={<FontIcon className="material-icons">schedule</FontIcon>}
            />
            <ListItem
              primaryText="Reports"
              leftIcon={<FontIcon className="material-icons">assessment</FontIcon>}
              primaryTogglesNestedList
              value="reports"
              nestedItems={[
                <ListItem
                  key="jobreport"
                  primaryText="Job Report"
                  value="jobreport"
                  onClick={() => this.handleShowJobReport('jobreport')}
                />,
                <ListItem
                  key="detaileditembreakdown"
                  primaryText="Item Breakdown"
                  value="detaileditembreakdown"
                  onClick={() => this.handleShowJobReport('detaileditembreakdown')}
                />,
                <ListItem
                  key="exceptions"
                  primaryText="Exceptions"
                  value="exceptions"
                  onClick={() => this.handleShowJobReport('exceptions')}
                />,
              ]}
            />
            { hasPermission('Administrator') ? <ListItem
              primaryText="Admin"
              value="admin"
              leftIcon={<FontIcon className="material-icons">settings</FontIcon>}
              primaryTogglesNestedList
              nestedItems={[
                <ListItem
                  key="jobprofiles"
                  primaryText="Job Profiles"
                  value="jobprofiles"
                  containerElement={<Link to="/jobprofiles"/>}
                />,
                <ListItem
                  key="taskprofiles"
                  primaryText="Task Profiles"
                  value="taskprofiles"
                  containerElement={<Link to="/taskprofiles"/>}
                />,
                <ListItem
                  key="roles"
                  primaryText="Roles"
                  value="roles"
                  containerElement={<Link to="/roles"/>}
                />,
                <ListItem
                  key="printers"
                  primaryText="Printers"
                  value="printers"
                  containerElement={<Link to="/printers"/>}
                />,
                <ListItem
                  key="billing"
                  primaryText="Billing"
                  value="billing"
                  containerElement={<Link to="/billing"/>}
                />,
              ]}
            /> : null }
          </SelectableList>
        </Drawer>
        <div style={styles.right}>
          <AppBar
            iconStyleRight={styles.icon}
            title={<span
              style={styles.title}
            >{this.props.title}</span>}
            iconElementRight={this.renderUserMenu()}
            style={styles.appBar2}
          >
          </AppBar>

          <div style={styles.main}>
            <div style={styles.main2}>
              { this.props.children }
            </div>
          </div>

          { this.props.isFindJobVisible ? <FindJobDialog /> : null }
          { this.props.isProfileVisible ? <UserProfile /> : null }
          { isDialogOpen(dialogs, 'confirm') ? <ConfirmDialog /> : null }
          { isDialogOpen(dialogs, 'alert') ? <AlertDialog /> : null }
          { isDialogOpen(dialogs, 'taskUpload') ? <TaskUploadDialog /> : null }
          { isDialogOpen(dialogs, 'address') ? <AddressDialog
            onRequestClose={_.get(dialogs, ['address', 'context', 'onRequestClose'])}/> : null }
          { isDialogOpen(dialogs, 'contact') ? <ContactDialog
            onRequestClose={_.get(dialogs, ['contact', 'context', 'onRequestClose'])}/> : null }
          { isDialogOpen(dialogs, 'tag') ?
            <TagDialog onRequestClose={_.get(dialogs, ['tag', 'context', 'onRequestClose'])}/> : null }

          { isDialogOpen(dialogs, 'upgrade') ? <UpgradeDialog/> : null }
          { isDialogOpen(dialogs, 'creditcard') ? <CreditCardCapture /> : null }
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logoutUser: () => logoutRoutine.trigger({ redirect: true }),
    showDialog,
    push,
  }, dispatch);
}

function mapStateToProps(state) {
  const dialogs = state.get('dialogs').get('dialogs').toJS();
  return {
    dialogs,
    tenant: state.get('tenants').get('tenant').toJS(),

    isFindJobVisible: isDialogOpen(dialogs, 'findjob'),
    isAlertVisible: isDialogOpen(dialogs, 'alert'),
    isProfileVisible: isDialogOpen(dialogs, 'profile'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js